<template>
  <div class="h-100">
    <div class="vue-datatables">
      <!-- Renewals Status Boxes -->
      <div class="row mb-3 flex-wrap"  >
      <div class="col-auto mb-2" v-for="status in renewalsStatuses" v-if="status.count">
        <div class="bg-white p-1 rounded shadow cursor-pointer d-flex justify-content-between align-items-center"
             :class="{'border' : status_id == status.key,[status.key]:true}"
             :style="{'border-color' : status_id == status.key ? status.color + '!important' : ''}"
             @click="status_id = status.key; filterInsuranceCompany($event, $route.name);">
          <span class="text-capitalize">{{ status.value }} ({{ status.count }})</span>

        </div>
        <div v-if="status_id != status.key" class="border-bottom-3 mt-1" :style="{'color' : status.color }"></div>
      </div>
    </div>

      <!-- Filters Section -->
      <div class="bg-white p-2 rounded shadow pt-4 pb-3">
        <div class="d-flex justify-content-between align-items-center px-3">
          <!-- Month Filter -->
          <select class="ml-1 form-control" ref="monthFilter" name="monthFilter" style="width: auto; max-width: 200px;"
                  v-model="selectedMonthFilter"
                  @change="doCustomFilter('month', $event.target.value)">
            <option value="">בחר חודש</option>
            <option v-for="month in months" :key="month.value" :value="month.value">
              {{ month.label }}
            </option>
          </select>

          <!-- Year Filter -->
          <select class="ml-1 form-control" ref="yearFilter" name="yearFilter" style="width: auto; max-width: 150px;"
                  v-model="selectedYearFilter"
                  @change="doCustomFilter('year', $event.target.value)">
            <option v-for="year in years" :key="year" :value="year.toString()">
              {{ year }}
            </option>
          </select>

             <!-- Product Type Filter -->
          <select class="ml-1 form-control" ref="productTypeFilter" name="productTypeFilter" style="width: auto; max-width: 200px;"
                  v-model="selectedProductTypeFilter"
                  @change="doCustomFilter('productType', $event.target.value)">
            <option value="">בחר סוג מוצר</option>
            <option v-for="product in productTypes" :key="product" :value="product">
              {{ product }}
            </option>
          </select>

          <div class="d-flex ml-auto">
            <!-- Upload CSV Button -->
            <input type="file" ref="file" style="display: none" @change="uploadCsv($event)" accept=".csv">
            <button @click="$refs.file.click()" title="העלה קובץ CSV"
                    class="btn btn-sm btn-light border mr-2" style="border-color: #ccc;">
              <span class="icon-upload"></span> העלה CSV
            </button>

            <!-- Print Button -->
            <!-- <button @click="print()" title="הדפס"
                    class="btn btn-sm btn-light border mr-2 d-none" style="border-color: #ccc;">
              <span class="icon-print"></span> הדפס
            </button> -->

            <!-- Download Excel -->
            <div class="btn-group dropleft " role="group">
              <button id="downloadBtnGroup" type="button" title="הורד"
                      class="btn btn-sm btn-light border" style="border-color: #ccc;"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="icon-download"></span> הורד
              </button>
              <div class="dropdown-menu" aria-labelledby="downloadBtnGroup">
                <a class="dropdown-item" href="#" @click.prevent="downloadExcel('renewals')">
                  Download Excel
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Campaign Actions Buttons Component (includes modals) -->
      <CampaignActionsButtons
        :previewOrderList="previewOrderList"
        :rows="rows"
        :statuses="renewalsStatuses"
        :tconfig="{ statusGroup: 7, statusGroupName: 'renewalStatus', options: options }"
        :routeName="$route.name"
        component="renewals"
        model="Renewals"
        @alert="handleAlert"
      />

      <!-- Loading Indicator -->
      <loader v-if="inProgress" />

      <!-- Data Table -->
      <v-server-table ref="myTable" @loading="onLoading(true)" @loaded="onLoading(false)"
                      :columns="columns"
                      :options="options">

        <!-- Table Headers -->
        <template v-for="(item, k) in columns" :slot="'h__' + item">
          <span>{{ getColumnLabel(item) }}</span>
          <input v-if="k === 0 " type="checkbox"  name="selectAll" v-model="rolesSelected" class="align-self-center" @click='selectAll($event)' />
        </template>


        <!-- Table Cells -->
        <template v-for="item in columns" :slot="item" slot-scope="props">
          <span v-if="item === 'statusId'" :style="{ border: '1px solid', borderColor: getStatusColor(props.row[item]), padding: '4px 8px', borderRadius: '4px' }">
            {{ getStatusName(props.row[item]) }}
          </span>
          <span v-else>{{ props.row[item] }}</span>
        </template>

        <!-- Actions Column -->
        <template v-slot:actions="props">
          <div class="d-flex justify-content-around h-100">
            <!--Add checkbox for multi messages -->
            <RowActions
              :route="$route"
              :id="'preview-order-list'+'_'+props.row.id"
              :value="props.row.id.toString()"
              :phoneNumber="props.row['carNumber']"
              :productSelectedRow="props.row"
              @catchPreviewList="catchPreviewList"
            />

            <button class="btn btn-link p-0" @click="handleOrderNavigation(props.row.orderId)" title="פתח הזמנה">
              <span class="icon icon-doublearrowleft"></span>
            </button>

          </div>
        </template>

      </v-server-table>
    </div>
  </div>
</template>

<script>
import axios from '../axios'
import config from '../table-config';
import DataTable from "@/mixins/DataTable";
import Auth from "@/mixins/Auth";
import Excel from "@/mixins/Excel";
import loader from '@/components/loader'
import RowActions from "@/components/rowActions.vue";
import CampaignActionsButtons from "@/components/CampaignActionsButtons.vue";
import { pickBy, isEqual } from "lodash";
import helpers from "@/helpers";

export default {
  name: "RenewalsView",
  components: { loader, RowActions, CampaignActionsButtons },
  mixins: [DataTable, Auth, Excel, helpers],
  data() {
    return {
      rows: [],
      statuses: [],
      inProgress: false,
      selectedStatusFilter: '',
      selectedMonthFilter: '',
      selectedProductTypeFilter: '',
      selectedYearFilter: new Date().getFullYear().toString(),
      options: {},
      renewalsStatuses: [],
      previewOrderList: [],
      isAdmin: false,
      isManagement: false,
      status_id: '',
      rolesSelected: '',
      months: [
        { value: 1, label: 'ינואר' },
        { value: 2, label: 'פברואר' },
        { value: 3, label: 'מרץ' },
        { value: 4, label: 'אפריל' },
        { value: 5, label: 'מאי' },
        { value: 6, label: 'יוני' },
        { value: 7, label: 'יולי' },
        { value: 8, label: 'אוגוסט' },
        { value: 9, label: 'ספטמבר' },
        { value: 10, label: 'אוקטובר' },
        { value: 11, label: 'נובמבר' },
        { value: 12, label: 'דצמבר' },
      ],
      productTypes: [],
      years: this.generateYears(),
      options: {
        perPageValues: [25, 50, 100],
        perPage: 50,
        initFilters: {
          GENERIC: "",
          ...pickBy(this.$route.query)
        },
        filterable: true,
        columnsDropdown: this.$store.getters.isAdmin || this.$store.getters.isManagement || '',
        sortable: [
          "actions",
          "id",
          "carNumber",
          "identityNumber",
          "customerName",
          "orderId",
          "productType",
          "startDate",
          "endDate",
          "month",
          "year",
          "userHandler",
          "statusId"
        ],
        sortIcon: {
          "base": "fontawesome",
          "up": "fa fa-chevron-up",
          "down": "fa fa-chevron-down",
          "is": "fa fa-sort"
        },
        customFilters: ["statusId", "month"],
        texts: {
          "count": "מציג {from} עד {to} מתוך {count} רשומות|{count} רשומות|רשומה 1",
          "filter": "",
          "filterPlaceholder": "ביטוי לחיפוש",
          "limit": "רשומות",
          "limitPlaceholder": "רשומות",
          "page": "עמוד",
          "noResults": "לא נמצאו רשומות",
          "filterBy": "סנן לפי {column}",
          "loading": "טוען...",
          "defaultOption": "בחר {column}",
          "columns": "עמודות"
        }
      }
    }
  },
  computed: {
    columns() {
      return ["actions", "carNumber", "identityNumber", "customerName", "orderId", "productType", "startDate", "endDate", "month", "year", "userHandler", "statusId"];
    }
  },
  methods: {
    onLoading(inProgress) {
      this.inProgress = inProgress
    },
    getColumnLabel(columnName) {
      const labels = {
        actions: 'פעולות',
        carNumber: 'מספר רכב',
        identityNumber: 'מספר זהות',
        customerName: 'שם לקוח',
        orderId: 'מספר הזמנה',
        productType: 'סוג מוצר',
        startDate: 'תאריך התחלה',
        endDate: 'תאריך סיום',
        month: 'חודש',
        year: 'שנה',
        userHandler: 'מטפל',
        statusId: 'סטטוס'
      };
      return labels[columnName] || columnName;
    },
    getStatusName(statusId) {
      // חזור את השם של הסטטוס לפי ה-ID
      if (!this.renewalsStatuses || this.renewalsStatuses.length === 0) return statusId;

      const status = this.renewalsStatuses.find(s => s.key == statusId);
      return status ? status.value : statusId;
    },
    getStatusColor(statusId) {
      // חזור את הצבע של הסטטוס לפי ה-ID
      if (!this.renewalsStatuses || this.renewalsStatuses.length === 0) return '#000';

      const status = this.renewalsStatuses.find(s => s.key == statusId);
      return status ? status.color : '#000';
    },
    doCustomFilter(filterName, filterValue) {
      if (filterName === 'statusId') {
        this.selectedStatusFilter = filterValue;
      } else if (filterName === 'month') {
        this.selectedMonthFilter = filterValue;
      } else if (filterName === 'productType') {
        this.selectedProductTypeFilter = filterValue;
      } else if (filterName === 'year') {
        this.selectedYearFilter = filterValue;
      }

      // Trigger table refresh
      this.$refs.myTable.refresh();
    },
    filterInsuranceCompany(event, routeName) {

      this.selectedStatusFilter = this.status_id;
      this.$refs.myTable.refresh();
    },
    async uploadCsv(event) {
      const file = event.target.files[0];
      if (!file) {
        console.log('No file selected');
        return;
      }

      // Read file content
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          this.inProgress = true;
          const csv = e.target.result;
          const rows = this.parseCSV(csv);

          // Send only the data (not the file)
          const response = await axios.post('/renewals/add', {
            data: rows,
            month: this.selectedMonthFilter,
            year: this.selectedYearFilter || new Date().getFullYear()
          });

          // Show success message
          this.$emit('alert', 'success', `הועלו ${rows.length} רשומות בהצלחה`);

          // Refresh table
          this.$refs.myTable.refresh();
        } catch (error) {
          console.error('Error uploading CSV:', error);
          const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message || 'שגיאה לא ידועה';
          this.$emit('alert', 'danger', 'שגיאה בהעלאת הקובץ: ' + errorMsg);
        } finally {
          this.inProgress = false;
          // Reset file input
          this.$refs.file.value = '';
        }
      };

      reader.readAsText(file);
    },
    parseCSV(csv) {
      const lines = csv.trim().split('\n');
      const headers = lines[0].split(',').map(h => h.trim());
      const rows = [];

      for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentLine = lines[i].split(',');

        for (let j = 0; j < headers.length; j++) {
          const value = currentLine[j];
          obj[headers[j]] = value ? value.trim() : '';
        }

        if (Object.values(obj).some(val => val !== '')) { // Skip empty rows
          rows.push(obj);
        }
      }

      return rows;
    },
    editRow(row) {
      // TODO: Implement edit functionality
      console.log('Edit row:', row);
    },
    deleteRow(id) {
      if (confirm('האם אתה בטוח שברצונך למחוק את הרשומה?')) {
        axios.delete(`/v2/renewals/${id}`)
          .then(() => {
            this.$emit('alert', 'success', 'הרשומה נמחקה בהצלחה');
            this.$refs.myTable.refresh();
          })
          .catch(error => {
            console.error('Error deleting row:', error);
            this.$emit('alert', 'danger', 'שגיאה במחיקת הרשומה');
          });
      }
    },
    print() {
      window.print();
    },
    async handleOrderNavigation(orderNumber) {
      try {
        this.inProgress = true;

        // Send order number to backend
        const response = await axios.post('/renewals/single', {
          orderId: orderNumber
        });

        const orderId = response.data.data.row.id || response.data.data.row.orderId;

        if (orderId) {
          // Navigate to orders view with the ID
          window.open(`/view?table=orders&source=renewals&id=${orderId}`, '_blank');
        } else {
          this.$emit('alert', 'danger', 'לא ניתן למצוא או ליצור את ההזמנה');
        }
      } catch (error) {
        console.error('Error navigating to order:', error);
        this.$emit('alert', 'danger', 'שגיאה בעת ניסיון לחיבור להזמנה');
      } finally {
        this.inProgress = false;
      }
    },
    generateYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 5; i <= currentYear + 5; i++) {
        years.push(i);
      }
      return years.sort((a, b) => b - a); // Sort descending
    },
    /**
     * Handle selecting all rows for bulk actions
     */
    selectAll(event) {
      let tmp = [];
      for (let row in this.rows) {
        let id = this.rows[row]['id'];
        let carNumber = this.rows[row]['carNumber'];
        let name = 'preview-order-list_' + id;
        let productSelectedRow = this.rows[row];

        $(`#${name}`).prop('checked', event.target.checked);

        if (event.target.checked) {
          let checked = {
            id: id,
            carNumber: carNumber,
            rowInfo: productSelectedRow
          };
          tmp.push(checked);
        }
      }

      this.previewOrderList = event.target.checked ? tmp : [];
    },
    /**
     * Catch preview list from row selection
     */
    catchPreviewList(carNumber, productSelectedRow) {
      let tmp = [];
      $("input[name='preview-order-list']").each(function() {
        if ($(this).is(':checked')) {
          let checked = {
            id: $(this).val(),
            carNumber: carNumber,
            rowInfo: productSelectedRow
          };
          tmp.push(checked);
        }
      });
      this.previewOrderList = tmp;
    },
    /**
     * Handle alert event from campaign component
     */
    handleAlert(type, message) {
      this.$emit('alert', type, message);
    },
    async fetchRenewals(params) {
      // Filter out empty parameters
      const cleanParams = {};
      for (let key in params) {
        if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
          cleanParams[key] = params[key];
        }
      }

      // Add custom filters
      if (this.selectedStatusFilter) {
        cleanParams.statusId = this.selectedStatusFilter;
      }
      if (this.selectedMonthFilter) {
        cleanParams.month = this.selectedMonthFilter;
      }
      if (this.selectedProductTypeFilter) {
        cleanParams.productType = this.selectedProductTypeFilter;
      }
      if (this.selectedYearFilter) {
        cleanParams.year = this.selectedYearFilter;
      }

      const query = pickBy(Object.assign({}, cleanParams));

      if (Object.keys(query).length && !isEqual(query, this.$route.query)) {
        try {
          await this.$router.push({ query });
        } catch (e) {
        }
      }

      try {
        const response = await axios.post(`/renewals/all`, cleanParams);

        // Handle the response format
        const data = response.data.data || response.data;
        const items = Array.isArray(data) ? data : (data.data || []);
        const total = response.data.total || response.data.count || 0;

        // Update product types from response
        if (response.data.data.productTypes && Array.isArray(response.data.data.productTypes)) {
          this.productTypes = response.data.data.productTypes;
        }
    

        return { data: items, count: total }
      } catch (e) {
        console.error('Error fetching renewals:', e);
        return { data: [], count: 0 }
      }
    }
  },
  async created() {
    // Set user permissions from store
    if (this.$store.getters.isAdmin) {
      this.isAdmin = this.$store.getters.isAdmin;
    }
    if (this.$store.getters.isManagement) {
      this.isManagement = this.$store.getters.isManagement;
    }

    // Restore filters from URL query params (for page refresh)
    if (this.$route.query.month) {
      this.selectedMonthFilter = this.$route.query.month.toString();
    }
    if (this.$route.query.year) {
      this.selectedYearFilter = this.$route.query.year.toString();
    }
    if (this.$route.query.statusId) {
      this.selectedStatusFilter = this.$route.query.statusId.toString();
      this.status_id = this.$route.query.statusId.toString();
    }
    if (this.$route.query.productType) {
      this.selectedProductTypeFilter = this.$route.query.productType.toString();
    }

    // Set requestFunction AFTER component is created so 'this' is properly bound
    this.options.requestFunction = async (params) => {
      return await this.fetchRenewals(params);
    };

    try {
      // Fetch statuses and options from API
      const response = await axios.post("renewals/getStatuses", {
        modeSource: this.$store.getters.currentModeSource || 'hova'
      });
      this.statuses = response.data.statuses || [];
      
      // Ensure renewalsStatuses is always an Array
      // API might return Object {20: {...}, 27: {...}, ...} so we convert to Array
      let renewalStatuses = response.data.renewalsStatus || [];
      if (renewalStatuses && typeof renewalStatuses === 'object' && !Array.isArray(renewalStatuses)) {
        renewalStatuses = Object.values(renewalStatuses);
      }
      this.renewalsStatuses = renewalStatuses;
      
      // Get product types if available from API
      if (response.data.productTypes) {
        this.productTypes = Array.isArray(response.data.productTypes) ? response.data.productTypes : Object.values(response.data.productTypes);
      }
      
      this.options = response.data;

      // Re-set the requestFunction after options are updated
      this.options.requestFunction = async (params) => {
        return await this.fetchRenewals(params);
      };
    } catch (e) {
      console.error('Error fetching renewal options:', e);
    }
  }
}
</script>

<style scoped>

</style>
